import { ethers } from 'ethers';
import React, { useState, useEffect } from 'react';

function AccountList() {
    const [accounts, setAccounts] = useState([]);

  async function getAccounts() {
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const accounts = await provider.listAccounts();
      const promises = accounts.map(async (account) => {
        const balance = await provider.getBalance(account);
        const formattedBalance = ethers.utils.formatEther(balance);
        return { address: account, balance: formattedBalance };
      });
      const allAccounts = await Promise.all(promises);
      setAccounts(allAccounts);
    }
  }

  useEffect(() => {
    getAccounts();
  }, []);

  return (
    <ul>
    {accounts.map((account) => (
      <li key={account.address}>
        {account.address} - {account.balance} ETH
      </li>
    ))}
  </ul>
  );
}

export default AccountList;
